import React, { useEffect, useState } from "react";
import { Icon, Step, StepContent, StepTitle } from "semantic-ui-react";
import OrderStatusHistory from "../types/entities/OrderStatusHistory";
import { getCurrentStatus } from "../utils/helpers";
import {
	ORDER_STATUS_AGENDADO,
	ORDER_STATUS_EN_PRODUCCION,
	ORDER_STATUS_LISTO_PARA_AGENDAR,
	ORDER_STATUS_PROYECTO_INCONCLUSO,
	ORDER_STATUS_PROYECTO_TERMINADO,
	ORDER_STATUS_RECIBIDO_EN_ALMACEN,
	ORDER_STATUS_VALIDANDO_PEDIDO
} from "../utils/constants";

interface Props {
	statusHistory: OrderStatusHistory[] | undefined;
}

const OrderStatusSteps = (props: Props) => {

	const defaultState = {
		disabled: true, active: false, completed: false
	};

	const [validatingOrder, setValidatingOrder] = useState(defaultState);
	const [inProduction, setInProduction] = useState(defaultState);
	const [receivedInStore, setReceivedInStore] = useState(defaultState);
	const [readyToSchedule, setReadyToSchedule] = useState(defaultState);
	const [scheduled, setScheduled] = useState(defaultState);
	const [projectCompleted, setProjectCompleted] = useState(defaultState);
	const [projectUnfinished, setProjectUnfinished] = useState(defaultState);

	useEffect(() => {
		if (props.statusHistory !== undefined) {
			switch (getCurrentStatus(props.statusHistory)) {
				case ORDER_STATUS_VALIDANDO_PEDIDO:
					setValidatingOrder({ disabled: false, active: true, completed: false });
					break;
				case ORDER_STATUS_EN_PRODUCCION:
					setValidatingOrder({ disabled: false, active: false, completed: true });
					setInProduction({ disabled: false, active: true, completed: false });
					break;
				case ORDER_STATUS_RECIBIDO_EN_ALMACEN:
					setValidatingOrder({ disabled: false, active: false, completed: true });
					setInProduction({ disabled: false, active: false, completed: true });
					setReceivedInStore({ disabled: false, active: true, completed: false });
					break;
				case ORDER_STATUS_LISTO_PARA_AGENDAR:
					setValidatingOrder({ disabled: false, active: false, completed: true });
					setInProduction({ disabled: false, active: false, completed: true });
					setReceivedInStore({ disabled: false, active: false, completed: true });
					setReadyToSchedule({ disabled: false, active: true, completed: false });
					setScheduled({ disabled: true, active: false, completed: false });
					break;
				case ORDER_STATUS_AGENDADO:
					setValidatingOrder({ disabled: false, active: false, completed: true });
					setInProduction({ disabled: false, active: false, completed: true });
					setReceivedInStore({ disabled: false, active: false, completed: true });
					setReadyToSchedule({ disabled: false, active: false, completed: true });
					setScheduled({ disabled: false, active: true, completed: false });
					break;
				case ORDER_STATUS_PROYECTO_TERMINADO:
					setValidatingOrder({ disabled: false, active: false, completed: true });
					setInProduction({ disabled: false, active: false, completed: true });
					setReceivedInStore({ disabled: false, active: false, completed: true });
					setReadyToSchedule({ disabled: false, active: false, completed: true });
					setScheduled({ disabled: false, active: false, completed: true });
					setProjectCompleted({ disabled: false, active: true, completed: false });
					break;
				case ORDER_STATUS_PROYECTO_INCONCLUSO:
					setValidatingOrder({ disabled: false, active: false, completed: true });
					setInProduction({ disabled: false, active: false, completed: true });
					setReceivedInStore({ disabled: false, active: false, completed: true });
					setReadyToSchedule({ disabled: false, active: false, completed: true });
					setScheduled({ disabled: false, active: false, completed: true });
					setProjectUnfinished({ disabled: false, active: true, completed: false });
					break;
			}
		}
	}, [props.statusHistory]);

	return (
		<Step.Group size="tiny" widths={6}>

			<Step disabled={validatingOrder.disabled} active={validatingOrder.active} completed={validatingOrder.completed}>
				<Icon name='upload' />
				<StepContent>
					<StepTitle>Validando pedido</StepTitle>
				</StepContent>
			</Step>

			<Step disabled={inProduction.disabled} active={inProduction.active} completed={inProduction.completed}>
				<Icon name='wrench' />
				<StepContent>
					<StepTitle>En producción</StepTitle>
				</StepContent>
			</Step>

			<Step disabled={receivedInStore.disabled} active={receivedInStore.active} completed={receivedInStore.completed}>
				<Icon name='warehouse' />
				<StepContent>
					<StepTitle>Recibido en almacen</StepTitle>
				</StepContent>
			</Step>

			<Step disabled={readyToSchedule.disabled} active={readyToSchedule.active} completed={readyToSchedule.completed}>
				<Icon name='phone' />
				<StepContent>
					<StepTitle>Listo para agendar</StepTitle>
				</StepContent>
			</Step>

			<Step disabled={scheduled.disabled} active={scheduled.active} completed={scheduled.completed}>
				<Icon name='checked calendar' />
				<StepContent>
					<StepTitle>Agendado</StepTitle>
				</StepContent>
			</Step>

			{getCurrentStatus(props.statusHistory) === ORDER_STATUS_PROYECTO_INCONCLUSO ? (
				<Step disabled={projectUnfinished.disabled} active={projectUnfinished.active} completed={projectUnfinished.completed}>
					<Icon name='undo' />
					<StepContent>
						<StepTitle>Proyecto inconcluso</StepTitle>
					</StepContent>
				</Step>
			) : (
				<Step disabled={projectCompleted.disabled} active={projectCompleted.active} completed={projectCompleted.completed}>
					<Icon name='flag checkered' />
					<StepContent>
						<StepTitle>Proyecto terminado</StepTitle>
					</StepContent>
				</Step>
			)}

		</Step.Group>
	);
};

export default OrderStatusSteps;
